var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBanks(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 910.00856,
    height: 506.27226,
    viewBox: "0 0 910.00856 506.27226",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M661.99572,461.51721l-71.05322-4.5293-3.83154-319.50098c-.09277-7.75488,2.99902-15.34863,8.4834-20.83301l76.12061-76.12061c10.65576-10.65479,27.42725-11.4248,39.01318-1.78662l82.60742,68.71826c6.73926,5.60596,56.06064,163.0559,55.95713,171.82153l-48.35361,91.07349,35.90381,49.86621,.07617,.10547,6.0835,52.72363-181.00684-11.53809Z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.93719,114.92589v-14.81543c0-3.91064,3.18164-7.09229,7.09229-7.09229h20.81592c3.91064,0,7.0918,3.18164,7.0918,7.09229v14.81543c0,3.91064-3.18115,7.09229-7.0918,7.09229h-20.81592c-3.91064,0-7.09229-3.18164-7.09229-7.09229Z",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.93719,229.92589v-54.81543c0-3.91064,3.18164-7.09229,7.09229-7.09229h30.81592c3.91064,0,7.0918,3.18164,7.0918,7.09229v54.81543c0,3.91064-3.18115,7.09229-7.0918,7.09229h-30.81592c-3.91064,0-7.09229-3.18164-7.09229-7.09229Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.59387,358.23691c-3.72461-.13184-6.72803-3.1543-6.83838-6.87988l-1.55811-52.98145c-.06641-2.26172,.9126-4.36328,2.68604-5.76855,1.77344-1.4043,4.04443-1.87305,6.23096-1.29297l1.55811,.41602c3.09961,.82715,5.26465,3.64453,5.26465,6.85254v52.56641c0,1.94141-.76953,3.75391-2.1665,5.10254-1.33496,1.28906-3.07275,1.98926-4.91846,1.98926-.08594,0-.17188-.00098-.2583-.00391Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.10363,356.25156c-1.39697-1.34863-2.1665-3.16113-2.1665-5.10254v-52.56641c0-3.20801,2.16504-6.02539,5.26514-6.85254l1.55811-.41602c2.18799-.58008,4.45752-.11133,6.23047,1.29297,1.77344,1.4043,2.75244,3.50684,2.68652,5.76855l-1.55859,52.98145c-.10986,3.72559-3.11328,6.74805-6.83838,6.87988-.08643,.00293-.17236,.00391-.2583,.00391-1.84521,0-3.5835-.70117-4.91846-1.98926Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800.48492,388.49167l21.95245,39.02658,2.52002,43.89001,17.47998,1.10999-6-52-36-50h0c-3.10706,5.59271-3.08905,12.39722,.04755,17.97342Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 753.01023,
    y: 459.33348,
    width: 71.25525,
    height: 1.00009,
    transform: "translate(-6.21249 10.82409) rotate(-.78329)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 752.38144,
    y: 450.28473,
    width: 67.55676,
    height: 1.00003,
    transform: "translate(-3.49763 6.15538) rotate(-.44761)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 751.81131,
    y: 441.63315,
    width: 64.63184,
    height: 1.00018,
    transform: "translate(-8.48428 15.39643) rotate(-1.11892)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 752.36495,
    y: 433.06324,
    width: 62.08985,
    height: 1.00055,
    transform: "translate(-13.95626 26.23612) rotate(-1.9017)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 751.79771,
    y: 425.09485,
    width: 59.659,
    height: 1.00061,
    transform: "translate(-14.47054 27.72494) rotate(-2.01348)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 749.36596,
    y: 417.01858,
    width: 58.07129,
    height: 1,
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 747.99893,
    y: 410.33205,
    width: 56.44,
    height: 1.00006,
    transform: "translate(-4.76079 9.12384) rotate(-.6714)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 746.73603,
    y: 403.91481,
    width: 54.71588,
    height: 1.00055,
    transform: "translate(-12.9941 25.91092) rotate(-1.9017)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 745.43264,
    y: 396.51848,
    width: 54.00928,
    height: 1.00015,
    transform: "translate(-6.85846 13.63724) rotate(-1.00705)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 743.71801,
    y: 389.92555,
    width: 51.73132,
    height: 1.00049,
    transform: "translate(-11.81935 24.22824) rotate(-1.78991)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 742.18602,
    y: 383.26857,
    width: 51.25244,
    height: 1.00006,
    transform: "translate(-3.71094 7.51609) rotate(-.55951)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738.43719,362.42639v-67.81543c0-3.91113,3.18164-7.09277,7.09229-7.09277h32.81592c3.91064,0,7.0918,3.18164,7.0918,7.09277v67.81543c0,3.91016-3.18115,7.0918-7.0918,7.0918h-32.81592c-3.91064,0-7.09229-3.18164-7.09229-7.0918Z",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.99572,461.51721l-58.09033-3.7002-.46826-.03027v-44.95703c0-5.68555,4.62549-10.31152,10.31104-10.31152h57.37793c5.68555,0,10.31104,4.62598,10.31104,10.31152v48.68848h-.5l-18.94141-.00098Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.43719,239.42638v-51.81592c0-3.91064,3.18164-7.09229,7.09229-7.09229h10.81592c3.91064,0,7.0918,3.18164,7.0918,7.09229v51.81592c0,3.91016-3.18115,7.0918-7.0918,7.0918h-10.81592c-3.91064,0-7.09229-3.18164-7.09229-7.0918Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.43738,466.51825l-3-44-9-42-2.5-11.5h0c-5.13733-3.49338-12.05536,.39255-11.74512,6.59735l.24512,4.90265,9,42,3,44",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.99478,445.51721l-84.53995-130.23786,9.65616-193.79241c-.09277-7.75488,2.99902-15.34863,8.4834-20.83301l31.38875-68.73935c10.65527-10.65625,72.1591-18.80559,83.74504-9.16789l82.60739,68.71826c6.73926,5.60596,10.54541,13.84863,10.44189,22.61426l-2.83838,240.28078,35.90381,49.86621,.07617,.10547,6.0835,52.72363-181.00781-11.53809h.00003Z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.93716,98.92589v-14.81543c0-3.91064,3.18164-7.09229,7.09277-7.09229h20.81543c3.91064,0,7.0918,3.18164,7.0918,7.09229v14.81543c0,3.91064-3.18115,7.09229-7.0918,7.09229h-20.81543c-3.91113,0-7.09277-3.18164-7.09277-7.09229Z",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.93716,213.92589v-54.81543c0-3.91064,3.18164-7.09229,7.09277-7.09229h30.81543c3.91016,0,7.0918,3.18164,7.0918,7.09229v54.81543c0,3.91064-3.18164,7.09229-7.0918,7.09229h-30.81543c-3.91113,0-7.09277-3.18164-7.09277-7.09229Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.50454,277.3912c-1.52344,1.20605-2.36426,3.0127-2.30664,4.95508l1.55762,52.98145c.09473,3.2002,2.6748,5.7959,5.87402,5.90918,1.68164,.06738,3.24707-.54688,4.44629-1.70508,1.2002-1.1582,1.86133-2.71484,1.86133-4.38281v-52.56641c0-2.75586-1.85938-5.17578-4.52246-5.88574l-1.55859-.41602c-.52734-.14062-1.06055-.20996-1.58887-.20996-1.35156,0-2.66699,.45312-3.7627,1.32031Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.10318,340.25156c-1.39648-1.34863-2.16602-3.16113-2.16602-5.10254v-52.56641c0-3.20801,2.16504-6.02539,5.26465-6.85254l1.55859-.41602c2.18359-.58008,4.45703-.11133,6.23047,1.29297,1.77441,1.40527,2.75293,3.50781,2.68652,5.76855l-1.55859,52.98145c-.10938,3.72559-3.1123,6.74805-6.83789,6.87988-.08594,.00293-.17285,.00391-.25879,.00391-1.84473,0-3.58301-.70117-4.91895-1.98926Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.48492,372.49167l21.95245,39.02658,2.52002,43.89001,17.47998,1.10999-6-52-36-50h0c-3.10706,5.59271-3.08905,12.39722,.04755,17.97342Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504.01023,
    y: 443.33348,
    width: 71.25525,
    height: 1.00009,
    transform: "translate(-6.01703 7.41863) rotate(-.78329)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 503.38144,
    y: 434.28471,
    width: 67.55676,
    height: 1.00003,
    transform: "translate(-3.38023 4.20966) rotate(-.44761)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 502.81131,
    y: 425.63317,
    width: 64.63184,
    height: 1.00018,
    transform: "translate(-8.21932 10.531) rotate(-1.11892)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 503.36493,
    y: 417.06325,
    width: 62.08985,
    height: 1.00055,
    transform: "translate(-13.56244 17.96428) rotate(-1.9017)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 502.79771,
    y: 409.09487,
    width: 59.659,
    height: 1.00061,
    transform: "translate(-14.06212 18.96654) rotate(-2.01348)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 500.36596,
    y: 401.01858,
    width: 58.07129,
    height: 1,
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 498.99893,
    y: 394.33203,
    width: 56.44,
    height: 1.00006,
    transform: "translate(-4.59039 6.20499) rotate(-.6714)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 497.73603,
    y: 387.9148,
    width: 54.71588,
    height: 1.00055,
    transform: "translate(-12.60028 17.63908) rotate(-1.9017)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 496.43263,
    y: 380.51849,
    width: 54.00928,
    height: 1.00015,
    transform: "translate(-6.61572 9.25849) rotate(-1.00705)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 494.71801,
    y: 373.92554,
    width: 51.73132,
    height: 1.00049,
    transform: "translate(-11.44109 16.44299) rotate(-1.78991)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 493.18602,
    y: 367.26856,
    width: 51.25244,
    height: 1.00006,
    transform: "translate(-3.56657 5.08381) rotate(-.55951)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.43719,346.42639v-67.81543c0-3.91113,3.18164-7.09277,7.09229-7.09277h32.81592c3.91064,0,7.0918,3.18164,7.0918,7.09277v67.81543c0,3.91016-3.18115,7.0918-7.0918,7.0918h-32.81592c-3.91064,0-7.09229-3.18164-7.09229-7.0918Z",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.99478,445.51721l-58.08984-3.7002-.46777-.03027v-44.95703c0-5.68555,4.62598-10.31152,10.31152-10.31152h57.37793c5.68555,0,10.31055,4.62598,10.31055,10.31152v48.68848h-.5l-18.94238-.00098Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.43719,223.42589v-51.81543c0-3.91064,3.18164-7.09229,7.09229-7.09229h10.81592c3.91064,0,7.0918,3.18164,7.0918,7.09229v51.81543c0,3.91064-3.18115,7.09229-7.0918,7.09229h-10.81592c-3.91064,0-7.09229-3.18164-7.09229-7.09229Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.43738,450.51825l-3-44-9-42-2.5-11.5h0c-5.13733-3.49338-12.05536,.39255-11.74512,6.59735l.24512,4.90265,9,42,3,44",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.99478,429.51721l-71.05176-4.5293L51.09808,209.41799c-.09277-7.75488,41.01194-119.27969,46.49631-124.76407L173.71548,8.53331c10.65527-10.65576,27.42773-11.42383,39.01172-1.78662l82.6084,68.71826c6.73926,5.60596,10.54492,13.84863,10.44141,22.61426l-2.83789,240.28078,35.9043,49.86621,.0752,.10547,6.08398,52.72363-181.00781-11.53809Z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.93716,82.92589v-14.81543c0-3.91064,3.18164-7.09229,7.09277-7.09229h20.81543c3.91016,0,7.0918,3.18164,7.0918,7.09229v14.81543c0,3.91064-3.18164,7.09229-7.0918,7.09229h-20.81543c-3.91113,0-7.09277-3.18164-7.09277-7.09229Z",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.93716,197.92589v-54.81543c0-3.91064,3.18164-7.09229,7.09277-7.09229h30.81543c3.91016,0,7.0918,3.18164,7.0918,7.09229v54.81543c0,3.91064-3.18164,7.09229-7.0918,7.09229h-30.81543c-3.91113,0-7.09277-3.18164-7.09277-7.09229Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.59439,326.23691c-3.72461-.13184-6.72852-3.1543-6.83887-6.87988l-1.55762-52.98145c-.06641-2.26172,.91211-4.36426,2.68555-5.76855s4.04395-1.87402,6.23047-1.29297l1.55859,.41602c3.09961,.82715,5.26465,3.64453,5.26465,6.85254v52.56641c0,1.94141-.76953,3.75391-2.16602,5.10254-1.33594,1.28906-3.07324,1.98926-4.91797,1.98926-.08594,0-.17285-.00098-.25879-.00391Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.33104,260.21329l1.55829-.41556c4.26292-1.13678,8.41766,2.15347,8.28796,6.56345l-1.55827,52.98154c-.10216,3.47351-2.88312,6.27124-6.35596,6.39429h-.00002c-3.72997,.13217-6.82567-2.8558-6.82567-6.5881v-52.56601c0-2.98663,2.00789-5.6001,4.89366-6.36966v.00006Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.48492,356.49167l21.95245,39.02658,2.52002,43.89001,17.47998,1.10999-6-52-36-50h0c-3.10706,5.59271-3.08905,12.39722,.04755,17.97342Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.01023,
    y: 427.33347,
    width: 71.25528,
    height: 1.00009,
    transform: "translate(-5.82157 4.01316) rotate(-.78329)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.38146,
    y: 418.28469,
    width: 67.55679,
    height: 1.00003,
    transform: "translate(-3.26283 2.26394) rotate(-.44761)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.81128,
    y: 409.63319,
    width: 64.63181,
    height: 1.00018,
    transform: "translate(-7.95436 5.66558) rotate(-1.11892)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.36496,
    y: 401.06324,
    width: 62.08988,
    height: 1.00055,
    transform: "translate(-13.16862 9.69245) rotate(-1.9017)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.7977,
    y: 393.09489,
    width: 59.659,
    height: 1.00061,
    transform: "translate(-13.6537 10.20814) rotate(-2.01348)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.36593,
    y: 385.01858,
    width: 58.07129,
    height: 1,
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.99893,
    y: 378.33202,
    width: 56.44,
    height: 1.00006,
    transform: "translate(-4.42 3.28614) rotate(-.6714)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.73602,
    y: 371.91481,
    width: 54.71591,
    height: 1.00055,
    transform: "translate(-12.20647 9.36725) rotate(-1.9017)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.4326,
    y: 364.51849,
    width: 54.00925,
    height: 1.00015,
    transform: "translate(-6.37297 4.87973) rotate(-1.00705)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.71804,
    y: 357.92554,
    width: 51.73135,
    height: 1.00049,
    transform: "translate(-11.06282 8.65773) rotate(-1.78991)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.18599,
    y: 351.26856,
    width: 51.25244,
    height: 1.00006,
    transform: "translate(-3.4222 2.65153) rotate(-.55951)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.43716,330.42639v-67.81543c0-3.91113,3.18164-7.09277,7.09277-7.09277h32.81543c3.91016,0,7.0918,3.18164,7.0918,7.09277v67.81543c0,3.91016-3.18164,7.0918-7.0918,7.0918h-32.81543c-3.91113,0-7.09277-3.18164-7.09277-7.0918Z",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.99478,429.51721l-58.08984-3.7002-.46777-.03027v-44.95703c0-5.68555,4.62598-10.31152,10.31152-10.31152h57.37793c5.68555,0,10.31055,4.62598,10.31055,10.31152v48.68848h-.5l-18.94238-.00098Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.43738,434.51825l-3-44-9-42-2.5-11.5h0c-5.13733-3.49338-12.05536,.39255-11.74512,6.59735l.24513,4.90265,8.99998,42,3,44",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 454.00416,
    y: -7.3531,
    width: 2.00024,
    height: 911.775,
    transform: "translate(-21.92052 873.687) rotate(-86.30501)",
    fill: "#ccc"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 46.64323,
    cy: 315.04557,
    r: 21.82055,
    fill: "#ff6884"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.94557,416.07562h0c0,.13991-.11342,.25334-.25334,.25334H1.50915v-.50667H234.69224c.13991,0,.25334,.11342,.25334,.25334Z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M114.59803,338.49527c-.72012-1.21427-3.83548,.08587-4.40822-1.01613-.57072-1.09802,2.32379-2.77105,3.97749-6.59297,.29824-.68923,2.1775-5.03256,.7863-6.37276-2.63703-2.54033-14.70417,7.94298-18.92711,4.51234-.9268-.75287-1.57426-2.25586-4.37918-4.69608-1.11587-.97076-1.79061-1.40907-2.44363-1.246-.92659,.23137-.99999,1.47149-1.99359,3.90981-1.49007,3.65676-2.37138,3.43595-3.23956,6.35344-.64449,2.1658-.49727,3.42496-1.25566,3.67026-1.07319,.34715-2.06101-1.95007-3.42109-1.74438-1.38788,.20992-2.22696,2.88465-2.49199,4.88726-.49737,3.75806,.88276,6.23787,1.64771,8.84541,.83127,2.83373,1.32463,7.14323-.59508,13.24392l-19.00086,53.53504c4.19481-10.98523,16.34077-41.09867,21.44449-52.28905,1.47336-3.23042,3.10014-6.50707,6.44043-7.80026,3.21592-1.24509,7.63258-.50171,13.2633-1.85821,.6576-.15839,2.48246-.6227,2.71215-1.69604,.18991-.88736-.88349-1.38268-.71857-2.21377,.2212-1.11478,2.33201-1.12847,4.92594-2.41461,1.82908-.90694,2.9686-1.98549,3.94849-2.91302,.29543-.27963,4.68694-4.48782,3.72828-6.10424h-.00003Z",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.843,366.67836c-.80376,.00307-1.0645,1.90725-1.77062,1.87039-.7036-.0367-.68957-1.94007-2.08823-3.85447-.25223-.34523-1.84173-2.52081-2.90094-2.22465-2.00767,.5613-.34416,9.5087-3.2464,10.59151-.63691,.23764-1.56142,.12176-3.56839,.79437-.79842,.26758-1.20823,.47228-1.31662,.83983-.15378,.52152,.43368,.9154,1.34374,2.10655,1.36482,1.78642,1.00215,2.15528,2.18357,3.42317,.87703,.94122,1.53752,1.23228,1.43908,1.67528-.13925,.62689-1.55176,.4489-1.84324,1.17577-.29741,.74176,.77325,1.92531,1.67967,2.63321,1.70099,1.32843,3.31629,1.36656,4.8168,1.74349,1.63066,.40962,3.88816,1.41092,6.32851,4.11339l20.793,24.77231c-4.1813-5.22843-15.45668-19.87843-19.47639-25.61218-1.16041-1.6552-2.29922-3.39906-1.97013-5.41165,.3168-1.93765,1.956-3.89086,2.91486-7.04585,.112-.36847,.41064-1.39809-.04987-1.82052-.38073-.34924-.93354,.0347-1.29386-.28606-.48331-.43024,.11901-1.47018,.23616-3.11438,.08262-1.1594-.11796-2.02987-.29046-2.77845-.05201-.22568-.85032-3.59525-1.92026-3.59113v.00008h0Z",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.87773,370.2778l-.48425-4.32279,.22125-.32771c1.02381-1.51537,1.54565-2.99527,1.55189-4.40002,.00104-.22333-.0094-.44669-.01983-.67419-.04175-.90171-.09391-2.02258,.49052-3.32923,.32771-.72846,1.24821-2.415,2.63209-2.20627,.37258,.05219,.65438,.22333,.86831,.4237,.03132-.05008,.06367-.10019,.09811-.15446,.43102-.6575,.77229-.93927,1.10104-1.21063,.25256-.20873,.51348-.4237,.92258-.93302,.1795-.22333,.31935-.41954,.43729-.58443,.35798-.49885,.82552-1.09375,1.65-1.08332,.88083,.04175,1.34213,.77021,1.64791,1.25238,.54583,.85996,.79317,1.4799,.95702,1.89108,.0595,.15029,.12734,.31935,.16177,.37154,.28387,.41746,2.5914,.02712,3.46073-.11481,1.95267-.32563,3.64233-.60739,4.33846,.62411,.49888,.88083,.12838,2.04554-1.13446,3.55467-.39346,.46965-.81196,.82656-1.1835,1.10627,.30788,.18369,.58337,.46546,.69508,.90798h0c.263,1.04781-.63767,2.09773-2.67592,3.12469-.50617,.25673-1.18767,.59906-2.1426,.76396-.44981,.07723-.85475,.09603-1.20123,.10646-.00731,.20038-.05427,.41746-.17637,.64079-.35798,.6575-1.10312,.97058-2.2261,.89544-1.23569-.06471-2.25323-.30056-3.15077-.50721-.78377-.1795-1.45902-.33187-1.98919-.2964-.9831,.07931-1.74081,.86623-2.62998,1.88692l-2.21983,2.5945h-.00002Z",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.12409,344.53988l-4.05859,1.56488-.37311-.1309c-1.72551-.60596-3.28935-.73535-4.64975-.38508-.2163,.05565-.42969,.12239-.64712,.1902-.86162,.26909-1.93263,.60388-3.34477,.36998-.78778-.1322-2.65262-.59482-2.80174-1.98637-.04402-.37362,.05005-.68962,.18962-.94739-.0564-.01757-.11307-.03615-.17429-.0557-.74532-.25017-1.10445-.5088-1.45033-.75798-.26597-.19137-.54011-.38921-1.13652-.65576-.26157-.11697-.48683-.20248-.67624-.27474-.57335-.21972-1.26737-.5211-1.46639-1.32128-.18304-.86261,.4046-1.49359,.79343-1.9117,.69339-.7461,1.2303-1.14261,1.58649-1.4054,.13028-.09566,.27661-.20418,.31836-.25071,.33179-.38047-.63106-2.51352-.98885-3.31843-.81027-1.8062-1.51142-3.36913-.49675-4.35486,.72549-.70597,1.94608-.64303,3.72618,.19571,.55409,.26147,1.00549,.57574,1.37029,.8642,.09959-.34439,.30225-.68238,.70199-.90264h0c.94684-.52017,2.19086,.08473,3.70124,1.79581,.37672,.42449,.88073,.99687,1.28244,1.87875,.18879,.41551,.30967,.80243,.40767,1.13495,.19569-.04376,.41756-.05339,.66458,.00807,.72679,.1795,1.21867,.82086,1.43081,1.92617,.25084,1.21169,.2808,2.25578,.30858,3.17638,.02517,.80368,.04904,1.49549,.21787,1.99931,.3261,.93084,1.27944,1.46415,2.49231,2.06535l3.07271,1.48914-.00011,.00003h0Z",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.87773,331.8048l-.48425-4.32279,.22125-.32771c1.02381-1.51537,1.54565-2.99527,1.55189-4.40002,.00104-.22333-.0094-.44669-.01983-.67419-.04175-.90171-.09391-2.02258,.49052-3.32923,.32771-.72846,1.24821-2.415,2.63209-2.20627,.37258,.05219,.65438,.22333,.86831,.4237,.03132-.05008,.06367-.10019,.09811-.15446,.43102-.6575,.77229-.93927,1.10104-1.21063,.25256-.20873,.51348-.4237,.92258-.93302,.1795-.22333,.31935-.41954,.43729-.58443,.35798-.49885,.82552-1.09375,1.65-1.08332,.88083,.04175,1.34213,.77021,1.64791,1.25238,.54583,.85996,.79317,1.4799,.95702,1.89108,.0595,.15029,.12734,.31935,.16177,.37154,.28387,.41746,2.5914,.02712,3.46073-.11481,1.95267-.32563,3.64233-.6074,4.33846,.62411,.49888,.88083,.12838,2.04554-1.13446,3.55467-.39346,.46965-.81196,.82656-1.1835,1.10627,.30788,.18369,.58337,.46546,.69508,.90798h0c.263,1.04781-.63767,2.09773-2.67592,3.12469-.50617,.25673-1.18767,.59907-2.1426,.76396-.44981,.07723-.85475,.09602-1.20123,.10646-.00731,.20038-.05427,.41746-.17637,.64079-.35798,.6575-1.10312,.97058-2.2261,.89544-1.23569-.06471-2.25323-.30056-3.15077-.50721-.78377-.1795-1.45902-.33187-1.98919-.2964-.9831,.07931-1.74081,.86623-2.62998,1.88692l-2.21983,2.5945h-.00002Z",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.30072,415.71401l-.9059-.56775-.21916-1.04573,.21916,1.04573-1.05617,.12106c-.01671-.0981-.07411-.32354-.1607-.6763-.47277-1.93283-1.91404-7.81483-3.11633-17.07823-.83911-6.46644-1.31396-13.11446-1.41206-19.7625-.09811-6.65845,.21708-11.69929,.46965-15.75071,.19098-3.05579,.42269-5.96548,.65018-8.80005,.60531-7.57271,1.17619-14.72585,.75141-22.64504-.09391-1.76794-.29119-5.44783-2.44108-9.3636-1.24717-2.27098-2.965-4.28729-5.10656-5.99052l1.33168-1.674c2.36385,1.88273,4.26433,4.11615,5.64928,6.63761,2.38369,4.34156,2.59869,8.35127,2.702,10.27783,.43206,8.05904-.14506,15.28108-.75665,22.92683-.22544,2.8241-.45713,5.72127-.64706,8.76454-.25048,4.01388-.56252,9.01083-.46546,15.58372,.09603,6.56871,.56565,13.13533,1.39327,19.52037,1.18767,9.14652,2.60809,14.94086,3.07458,16.84445,.2484,1.01652,.30056,1.22942,.04592,1.63228v0Z",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.05321,318.59643c-.08767,0-.17637-.00208-.26613-.00836-1.82013-.09811-3.5056-1.18766-5.01054-3.2374-.7055-.96434-1.0666-2.06433-1.78673-4.25809-.11167-.33815-.65438-2.0539-.98417-4.41462-.21604-1.54252-.1889-2.18748,.1169-2.75731,.33919-.63454,.88815-1.07704,1.50598-1.37552-.02712-.20456-.00523-.41537,.0835-.63038,.36423-.89127,1.33273-.77437,1.85665-.71802,.26508,.03339,.59592,.07723,.95285,.05843,.56148-.02712,.8631-.19413,1.32021-.44461,.43729-.24004,.98102-.53852,1.78777-.70342,1.59052-.33187,2.92325,.11898,3.36262,.26717,2.31166,.77021,3.45133,2.56738,4.7705,4.64839,.263,.41746,1.16575,1.937,1.76166,4.02012,.42998,1.50285,.36946,2.17079,.24004,2.66756-.263,1.02069-.88395,1.60512-2.46092,2.89509-1.64687,1.35048-2.47344,2.02677-3.18313,2.43796-1.65208,.9539-2.68948,1.55294-4.06708,1.55294v.00005Z",
    fill: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "b-174",
    d: "M157.17762,400.0235c2.51467,2.70798,5.95026,3.60553,7.67337,2.00489s1.08112-5.09281-1.4348-7.80141c-.99017-1.09577-2.22834-1.93847-3.61098-2.4576l-10.79965-11.33928-5.21317,5.18139,11.20002,10.62841c.41578,1.41762,1.16508,2.71504,2.1852,3.78362h0Z",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "c-175",
    d: "M134.52002,392.25081c3.49731,1.19397,6.94822,.35726,7.7077-1.86858,.75949-2.22583-1.45993-4.99742-4.95864-6.19134-1.39105-.49609-2.88068-.65185-4.34426-.45421l-14.88213-4.87175-2.13731,7.03248,14.89805,4.05606c1.03762,1.05162,2.31203,1.83938,3.71659,2.29735h0Z",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.13661,349.64476s-9.22524,11.09839-3.88829,15.69029,29.17029,21.5908,29.17029,21.5908l9.29136,1.44683,2.37644-8.9814-20.98037-15.54632-15.96943-14.2002h0Z",
    fill: "#6c63ff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M118.75684,340.35572l.06604,.0111c.54401,.09005,3.83308,.59751,7.14911-.66567,1.40478-.53513,.92557-.6685,4.05425-2.52895,3.66803-2.18117,4.60938-2.16593,4.88253-3.18296,.54542-2.03086-2.36699-5.22342-4.29469-5.01322-.50752,.05534-1.05105,.35792-1.89643,.15275-.18574-.04507-.9988-.24239-1.39517-.9154-.35359-.60038-.05411-1.03347-.19631-1.52586-.37326-1.29247-3.48472-1.93748-6.21262-1.48174-1.56897,.26212-2.78934,.97773-5.16597,2.39825-4.13663,2.47245-6.20491,3.70868-6.66977,5.60272-.4406,1.79521,.6169,2.56874-.1522,4.49045-.71614,1.78934-1.85355,1.66984-2.24495,3.11734-.62985,2.32931,1.70787,4.88574,2.68169,5.95068,1.06768,1.16757,2.08877,1.80838,3.44434,2.65908,1.70149,1.06779,2.55221,1.60168,3.57504,1.54736,1.85444-.09848,7.36493,.23676,7.4368-1.29784,.02693-.57512,6.71022-.10422,3.41934-6.296-.40364-.75945-8.31106,.05176-8.41543-.38452",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.26128,
    cy: 336.72631,
    r: 10.44751,
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.89619,337.40239l.06604,.0111c.54401,.09005,3.83308,.59751,7.14911-.66567,1.40478-.53513,.92557-.6685,4.05425-2.52895,3.66803-2.18117,4.60938-2.16593,4.88253-3.18296,.54542-2.03086-2.36699-5.22342-4.29469-5.01322-.50752,.05534-1.05105,.35792-1.89643,.15275-.18574-.04507-.9988-.24239-1.39517-.9154-.35359-.60038-.05411-1.03347-.19631-1.52586-.37326-1.29247-3.48472-1.93748-6.21262-1.48174-1.56897,.26212-2.78934,.97773-5.16597,2.39825-4.13663,2.47245-6.20492,3.70868-6.66977,5.60272-.4406,1.7952,.6169,2.56874-.1522,4.49045-.71614,1.78934-1.85355,1.66984-2.24495,3.11734-.62985,2.32931,1.70787,4.88574,2.68169,5.95068,1.06768,1.16757,2.08877,1.80838,3.44434,2.65908,1.70149,1.06779,2.55221,1.60168,3.57504,1.54736,1.85444-.09848,3.69892-1.77905,3.7708-3.31366,.02693-.57512-.21299-.74759-.80677-2.72471-.24737-.82371-.41896-1.50371-.52332-1.94",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.46759 431.30063 194.32454 444.87181 200.05459 436.42752 191.6103 428.58639 183.46759 431.30063",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.83348,398.42821s33.37823,3.92056,36.14114,6.6348c2.76292,2.71424,19.34993,25.63446,19.34993,25.63446l-6.93638,5.42847-17.88476-19.01379-38.12496-.2976,7.45504-18.38633h0Z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.92839 398.42821 167.78534 411.99939 173.51539 403.5551 165.0711 395.71397 156.92839 398.42821",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.27743,408.07883s-2.41265-.60316-2.41265,1.50791,.60316,8.44429,.60316,8.44429c0,0,27.74553-4.82531,27.74553-7.84113s-7.53955-2.41265-7.53955-2.41265l-10.85695-5.12689-7.53955,5.42847Z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.58004 467.79202 114.70693 486.79168 122.84964 485.28377 121.04015 465.68095 109.58004 467.79202",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.91326,485.58535l-3.01582,.60316-2.41265,8.14271s3.92056,1.50791,3.92056,4.52373,1.50791,5.12689,7.53955,4.82531,6.6348,0,6.6348-2.41265-4.52373-15.07909-4.52373-15.07909c0,0,.30158-5.12689-3.3174-4.82531s-4.82531,4.22215-4.82531,4.22215Z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.01066 467.49644 82.3605 487.17256 90.62539 487.69125 93.64001 468.23727 82.01066 467.49644",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8241,486.29601l-3.07194-.14877-4.32142,7.31095s3.43583,2.41654,2.70203,5.34172,.21512,5.33971,6.13887,6.5148,6.4354,1.61438,7.02244-.72577-.71875-15.72662-.71875-15.72662c0,0,1.53998-4.89943-2.04361-5.48749-3.5836-.58805-5.70762,2.92117-5.70762,2.92117h0Z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.45349,349.87352l-16.28542-1.20633-3.61898,4.52373s-1.80949,30.45976-.60316,33.47558,.30158,20.20598,.30158,20.20598l41.05431-2.86503-9.08663-21.86468,.30158-12.66644-8.14271-15.38067-3.92056-4.22215h0Z",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.05699,400.53928s-6.6348,9.65062-4.22215,14.77751,18.77793,34.89537,18.77793,34.89537l-2.11107,27.74553,14.47593-1.20633,2.41265-29.8566-10.03205-24.34001,1.80949-2.71424,15.07909,18.39649,5.42847,31.96767,14.47593-1.80949-7.84113-46.74519-9.16387-18.01694-39.08922-3.09379h0Z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.35755,348.96878l-12.06327-1.20633-9.9522,9.65062s-4.82531,13.87276-3.92056,21.41231,8.74587,26.23762,8.74587,26.23762l12.36486-9.04746,14.17435,.60316v-28.23352l-7.23796-15.79743-2.11107-3.61898h0Z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.01643,352.58465s6.93696,.90029,9.93816,6.06225,24.63568,29.45064,24.63568,29.45064l-4.09893,3.75053-21.31689-13.75369-8.18493-14.07781-.97309-11.43193h0Z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.11185,401.8964s-1.05554,12.51565,5.57926,14.32514c6.6348,1.80949,23.82497,.30158,23.82497,.30158l10.85695-28.04711,10.55536,12.66644,10.25378-4.82531s-10.85695-30.45977-16.88858-30.45977-15.68226,8.44429-15.68226,8.44429l-15.68226,21.11073-12.81723,6.48401Z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.81663,440.95125s-2.41265-.60316-2.41265,1.50791,.60316,8.44428,.60316,8.44428c0,0,27.74553-4.82531,27.74553-7.84113s-7.53955-2.41265-7.53955-2.41265l-10.85695-5.12689-7.53955,5.42847h0Z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.6395,
    cy: 325.8135,
    r: 5.59121,
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.55168,
    cy: 334.36517,
    r: 12.17633,
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.69098,347.7143c-1.29414,.68555-4.93562-1.83135-6.23854-5.20388-.83819-2.16962-2.87603-1.80866-4.1764-4.5144-.75771-1.5766,1.50494-3.11889,1.13175-4.48204-.6762-2.46989,.17155-4.67966,.27957-4.95038,.93237-2.33687,2.30674-2.28251,3.41502-5.00252,.66724-1.63758,.2392-1.82938,.80005-2.66711,1.61864-2.41775,6.31511-2.50973,9.62749-1.36636,1.14622,.39565,3.90723-1.72445,6.14849-.18857,2.64061,1.80955,4.39734,7.02556,3.99317,7.98136-.24555,.58069-1.6127-.01091-4.45597,.43598-2.63241,.41374,.84191,2.3805-2.12057,3.05095-3.50315,.7928-4.55846,.06932-5.52929,1.17759-1.02625,1.17154-1.216,3.54281-.27957,4.95038,.46469,.69849,1.06389,.94497,.98882,1.43109-.13705,.88748-.92533,.40505-1.18388,1.34659-.30073,1.09513,2.19456,2.53098,1.97763,2.86218-.04371,.06673-.23058,.139-2.66711-.80005-.97291-.37496-1.34803-.69869-1.45716-.57891-.17666,.19391-1.05147,2.13834-.05749,2.96544,1.54684,1.28713,.47474,1.79827,1.17989,2.80612,.72749,1.03975-.55346,.31087-1.3759,.74655h0Z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "d-176",
    d: "M77.54203,418.06734c1.94324,3.14333,5.14027,4.68861,7.1405,3.45159,2.00023-1.23701,2.04601-4.78742,.10166-7.93161-.75946-1.26663-1.81121-2.33297-3.06727-3.1098l-8.40178-13.21445-6.11711,4.07488,8.9321,12.59448c.13365,1.47128,.61778,2.88914,1.41188,4.1349h0Z",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.45383,353.79409s-14.17435,2.71424-12.96802,9.65062,8.82082,35.20315,8.82082,35.20315l6.25827,7.0183,7.53955-5.42847-6.33322-25.33288-3.3174-21.11073h0Z",
    fill: "#6c63ff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "e-177",
    d: "M134.14293,419.18951c1.93521,3.14829,5.12829,4.70171,7.13167,3.46979s2.05822-4.78218,.1219-7.93132c-.75623-1.26856-1.80526-2.33758-3.05931-3.11761l-8.36803-13.23585-6.12749,4.05926,8.89994,12.61724c.1299,1.47162,.61041,2.89071,1.40133,4.13849h0Z",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.31315,355.60422l-11.93629,2.99323s4.17955,14.89345,5.15891,20.23263c.97935,5.33918,21.59173,34.75634,21.59173,34.75634l6.23468-7.4579-18.25657-33.64579-2.79245-16.87852h0Z",
    fill: "#e6e6e6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanks);
export default __webpack_public_path__ + "static/media/banks.3b7fbda21c027b705fee7fa0466935b1.svg";
export { ForwardRef as ReactComponent };